module.exports = __webpack_public_path__ + "media/country_flags/gf-20c82e13.png";